module.exports = import("https://cdn.socket.io/4.8.1/socket.io.esm.min.js");;